/* eslint-disable no-underscore-dangle */

declare global {
	interface Window {
		__ENV__?: Record<string, string>;
	}
}

type ViteEnvKey = `VITE_${string}`;

export function env(key: ViteEnvKey, fallback?: string): string {
	return (import.meta.env.PROD ? window.__ENV__?.[key] : import.meta.env[key]) ?? fallback ?? '';
}

export function envNumber(key: ViteEnvKey, fallback: number): number {
	const value = env(key).trim();

	return value !== '' && Number.isFinite(Number(value)) ? Number(value) : fallback;
}
